import React from "react";
import Fade from "react-reveal/Fade";

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const Location = () => {
  return (
    <section id="location">
      <Fade duration={1000} delay={200}>
        <LoadScript
          // id="script-loader"
          googleMapsApiKey="AIzaSyATncUl3nlH2mJsaPpY_Cw3YQW5WP-0yTQ"
        >
          <GoogleMap
            id="e-gov-academy-map"
            mapContainerStyle={{
              height: "55vh"
            }}
            zoom={15}
            center={{
              lat: 24.73879,
              lng: 46.639914
            }}
          >
            {/* <InfoWindow
      onLoad={infoWindow => {
        console.log('infoWindow: ', infoWindow)
      }}
      position={{ lat: 24.738790,
        lng: 46.639914}}
    >
      <div style={{
        background: `white`,
        border: `1px solid #ccc`,
        padding: 15
      }}>
        <h1>أكاديمية الحكومة الرقمية</h1>
      </div>
    </InfoWindow> */}

            <Marker
              onLoad={marker => {
                // console.log('marker: ', marker)
              }}
              position={{
                lat: 24.73879,
                lng: 46.639914
              }}
            />
          </GoogleMap>
        </LoadScript>
      </Fade>
    </section>
  );
};

export default Location;
